import { Palette } from '@mui/material'

export const dialogButtonStyle = {
	margin: '0 16px',
	borderRadius: '24px',
	fontSize: '14px',
	height: '48px',
}

export const linkStyle = {
	marginRight: '26px',
	fontSize: '14px',
	cursor: 'pointer',
	textUnderlineOffset: '5px',
	'& > span': { marginLeft: '4px' },
}

export const iconStyle = {
	width: '20px',
	height: '20px',
	verticalAlign: 'middle',
}

export const detailsLabelStyle = (palette: Palette) => ({
	color: palette.text.lightGrey,
	fontSize: '14px',
	width: '15%',
	lineHeight: '2.2',
})

export const detailsValueStyle = (palette: Palette) => ({
	color: palette.text.darkGrey,
	fontSize: '14px',
	textTransform: 'capitalize',
	lineHeight: '2.2',
})

export const detailsCampaignMessageStyle = (palette: Palette) => ({
	...detailsValueStyle(palette),
	textTransform: 'none',
})
